

import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import {IShortUser} from "@/model/shortInterfaces";
import {ILocker} from "@/model/Locker/lockerInterfaces";
import UserSearch from "@/components/user/widget/UserSearch.vue";
import Datim from "@/components/shared/Datim.vue";
import LockerChip from "@/components/shared/chips/LockerChip.vue";
import UserChip from "@/components/shared/chips/UserChip.vue";
import {BoListPanel} from "bonomo/dist";
import PaginationBar from "@/components/shared/PaginationBar.vue";
import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";

const lockerModule = namespace("lockerModule");
const userModule = namespace("userModule");

@Component({
  components: {
    BoListPanel,
    UserChip,
    LockerChip,
    UserSearch,
    Datim,
    PaginationBar,
  }
})

export default class UserListView extends Vue {
  @userModule.Getter('userList')
  private users!: IShortUser[];

  @lockerModule.Getter('lockers')
  private lockers!: ILocker[];

  @userModule.Getter('currentPage')
  private currentPage!: number;

  @userModule.Getter('lastPage')
  private lastPage!: number;

  @userModule.Getter('total')
  private total!: number;

  @userModule.Getter('perPage')
  private perPage!: number;

  @userModule.Action('clearUsers')
  protected clearUsers!: () => Promise<any>;
  @userModule.Action('fetchUsers')
  protected fetchUsers!: (filters: any) => Promise<any>;

  protected get headers(): BetterDataTableHeader[] {
    return [
      // { text: this.$t('common.id'), align: 'start', sortable: false, value: 'id' },
      { text: this.$t('users.userList.email'), align: 'start', sortable: false, value: 'email' },
      { text: this.$t('users.userList.firstName'), align: 'start', sortable: false, value: 'first_name' },
      { text: this.$t('users.userList.lastName'), align: 'start', sortable: false, value: 'last_name' },
      { text: this.$t('users.userList.phone'), align: 'start', sortable: false, value: 'phone_number' },
      { text: this.$t('lockers.locker.title'), align: 'start', sortable: false, value: 'locker_id' },
      { text: this.$t('users.userList.createdAt'), align: 'start', sortable: false, value: 'created_at' },
{ text: '', value: 'detailButton' },
    ];
  }
  protected selectedPerPage: number = 15;
  protected readonly perPageOptions: number[] = [15, 30, 50, 100];

  protected loading: boolean = false;

  loadData(initial: boolean = false) {
    if (initial || !this.lockers.length) {
      this.$store.dispatch('lockerModule/fetchLockers');
    }
  }

  mounted() {
    this.loadData(true);
    this.fetchUsers({ page: 1, per_page: this.selectedPerPage });
  }

  toUserDetail(userId: number): any
  {
    return {name: 'user', params: { userId: `${ userId}`, }};
  }

  getLockerName(lockerId: number): string
  {
    for (var i = 0; i < this.lockers.length; i ++) {
      if(this.lockers[i].id == lockerId)
      {
        return this.lockers[i].name;
      }
    }
    return '---';
  }

  gotoUser(user: IShortUser) {
    return this.$router.push({name: 'user', params: { userId: ''+user.id}});
  }

  protected onPageChange(page: number) {
    this.clearUsers().then(() => {
      this.fetchUsers({ page, per_page: this.selectedPerPage });
    });
  }

  protected onPerPageChange(value: number) {
    this.selectedPerPage = value;
    this.clearUsers().then(() => {
      this.fetchUsers({ page: 1, per_page: this.selectedPerPage });
    });
  }
}
